var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogPencil = function SvgBlogPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 153,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blogPencil_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA00",
    d: "M7.387 143.258c-3.477-4.522-2.627-11.032 1.894-14.509L146.263 23.402l33.703-13.182-21.084 29.582-136.986 105.35c-4.521 3.477-11.032 2.627-14.509-1.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m177.942 11.801-19.593 27.485-136.9 105.284c-4.208 3.236-10.245 2.448-13.48-1.759-3.236-4.208-2.448-10.245 1.76-13.48l136.9-105.285zm4.055-3.161-4.592 1.797-31.313 12.245-.195.076L8.834 128.167c-4.843 3.725-5.753 10.695-2.029 15.538 3.725 4.844 10.695 5.753 15.538 2.029L159.415 40.318l.128-.179 19.593-27.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA2AF",
    d: "M7.899 142.76c-3.478-4.522-2.628-11.032 1.894-14.509l2.288-1.76 12.614 16.403-2.287 1.76c-4.522 3.477-11.032 2.627-14.51-1.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m23.666 142.76-1.706 1.312c-4.207 3.236-10.244 2.448-13.48-1.76-3.235-4.207-2.447-10.244 1.76-13.48l1.706-1.312zm2.058.268-13.509-17.566-2.87 2.207c-4.843 3.725-5.753 10.695-2.028 15.538s10.695 5.753 15.538 2.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCEDB",
    d: "m30.565 138.04-12.152-15.801-6.212 4.777 12.152 15.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m29.574 137.908-5.091 3.915-11.288-14.677 5.092-3.916zm1.99.259-13.015-16.922-7.336 5.642 13.014 16.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m145.51 24.364-1.439 1.107 11.72 15.24 1.439-1.107 19.59-27.489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "m174.356 17.12 4.476-6.28-7.476 3.021z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blogPencil_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m175.353 0 13.56 17.633L13.561 152.489 0 134.856z"
  })))));
};
export { SvgBlogPencil as ReactComponent };
export default "/_next/static/media/src/components/Blog/assets/blogPencil.80d431925d66449413cc17af4ef14b17.svg";